<div class="row">
  <div class="col-12 d-flex align-items-center justify-content-between mb-3">
    <h5 class="bergh-text-primary m-0">Documenten</h5>
    @if (!isCustomer) {
    <button
      class="btn bergh-btn-secondary text-white"
      id="btn-export"
      (click)="openModal.emit()"
    >
      <i-feather name="upload" class="small-icon mr-2"></i-feather> Upload nieuw
      bestand
    </button>
    }
  </div>
  @if (data.length <= 0) {
  <div class="col-12">
    <div class="alert alert-primary bergh-text-primary text-center">
      Geen data gevonden
    </div>
  </div>
  } @if (data.length > 0) {
  <div class="col-12">
    <table class="table border bg-white">
      <thead>
        <tr>
          <th>Bestandsnaam</th>
          <th>Gekoppeld aan</th>
          <th>Aanmaakdatum</th>
          @if (isShow) {
          <th>Acties</th>
          }
        </tr>
      </thead>
      <tbody>
        @for (document of data; track document; let i = $index) {
        <tr>
          <td>
            <a href="{{ document.url }}" target="_blank">
              {{ document.filename }}
            </a>
          </td>
          <td>
            {{
              document.linkedFirePartitions > 0
                ? document.linkedFirePartitions + "afdichtingen"
                : "Document"
            }}
          </td>
          <td>
            {{ document.createdAt | date : "dd-MM-yyyy" }}
          </td>
          @if (isShow) {
          <td class="btn-clc d-flex btn-delete">
            <div class="info-window bergh-shadow-one">
              <p class="text-dark">
                Weet je zeker dat je dit wilt verwijderen?
              </p>
              <div class="btn-collection">
                <button
                  class="btn btn-sm btn-secondary"
                  #no
                  type="button"
                  (click)="cancelDelete(no)"
                >
                  Nee
                </button>
                <button
                  class="btn btn-sm btn-danger"
                  #yes
                  (click)="deleteDocument(document._id); cancelDelete(yes)"
                  type="button"
                >
                  Ja
                </button>
              </div>
            </div>
            <button
              class="btn bergh-btn-secondary text-white"
              [ngClass]="{
                'bergh-btn-secondary': document.isPublished,
                'btn-secondary': !document.isPublished
              }"
              title="Publiceren"
              id="primaryBtn-0-0"
              id="btn-publish-{{ i }}"
              (click)="publishDocument(document._id, document.isPublished)"
            >
              <i-feather
                name="{{ document.isPublished ? 'eye' : 'eye-off' }}"
                class="small-icon"
              ></i-feather>
            </button>
            @if (link) {
            <button
              class="btn text-white"
              (click)="openLinkDelinkModel(document._id)"
              [ngClass]="{
                'bergh-btn-secondary': document.linkedFirePartitions > 0,
                'btn-secondary': document.linkedFirePartitions === 0
              }"
              title="Koppelen/Ontkoppelen"
              id="primaryBtn-0-1"
              id="btn-link-{{ i }}"
              style="background-color: grey"
            >
              <i-feather name="link" class="small-icon"></i-feather>
            </button>
            }
            <button
              class="btn btn-danger text-white icon-btn"
              title="Verwijderen"
              id="deleteBtn-0-0"
              id="btn-delete-{{ i }}"
              #delete
              (click)="openDelete(delete)"
            >
              <i-feather name="trash-2" class="small-icon"></i-feather>
            </button>
          </td>
          }
        </tr>
        }
      </tbody>
    </table>
  </div>
  }
</div>
@if (isLinkDelink) {
<bergh-link-unlink
  [docId]="docId"
  (cancel)="isLinkDelink = $event"
></bergh-link-unlink>
}
